export default __webpack_public_path__ + "static/media/create-group-ctd.0687f6ff.png";